export default {
  termsAndConditions: 'https://ventas.primeraplus.com.mx/web/primerapluspublico/terminos-y-condiciones',
  noticeOfPrivacy: 'https://ventas.primeraplus.com.mx/web/primerapluspublico/solicitud-de-derechos-arco',
};



// WEBPACK FOOTER //
// ../config/hrefConfig.js